import React from 'react'

const UserDetails = () => {
  return (
    <div className='text-center my-8 '>userDetails has to submit their <br/> first name <br/>last name <br/> phone number <br/> email<br/> and then can download pdf</div>
  )
}

export default UserDetails